module.exports = __webpack_public_path__ + "static/img/son2_active.c4b26374.png";